/**
 * @generated SignedSource<<a2369b0163fd74c53876b5cc2160ff5e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HiringProviders_query$data = {
  readonly company: {
    readonly lang: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "HiringProviders_query";
};
export type HiringProviders_query$key = {
  readonly " $data"?: HiringProviders_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"HiringProviders_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HiringProviders_query",
  "selections": [
    {
      "alias": "company",
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "companyDomainName",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lang",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "ae7d8d0c6f78752c2e13f93622d427fa";

export default node;
